<template>
  <div id="past" class="tab-pane tab-box">
    <div class="orders-lst skelton" v-if="is_skel_loader">
      <a href="javascript:void(0);">
        <div class="order-item d-flex align-items-start">
            <div class="img-cls">
              <skeleton-loader-vue width="60px" height="60px" style="border-radius: 5px;"/>
              </div>
            <div class="order-data ml-3 d-flex align-items-start justify-content-between w-100">
              <div class="orders-status-main delivery-link">
                  <h6 class="mb-1"><skeleton-loader-vue type="string" width="130px" height="20px" /></h6>
                 <skeleton-loader-vue type="string" width="50px" height="20px" />
                  <p class="mt-2"><skeleton-loader-vue type="string" width="100px" height="20px" /></p>
              </div>
              <div class="order-status">
                  <p class="order-status-btn"><skeleton-loader-vue type="circle" width="100px" height="20px" style="border-radius: 20px !important;"/></p>
              </div>
            </div>
        </div>
      </a>
    </div>
    <div v-else>       
    <div class="orders-lst new-orders-lst" v-if="pastorders.length > 0">
      <div class="pastorderloop" v-for="(past,index) in pastorders" :key="index">
        <router-link :to="{ name: past.order_status == 'Cancelled'? 'order-details':'order-status',params: { order_id: base64_encode(past.id) }}">
          <div class="order-item d-flex align-items-start">
            <div class="img-cls resimg-squre">
              <img  v-if="past.icon_image" :src="past.icon_image" @error="$event.target.src = noImge"/>              
            </div>
            <div class="order-data ml-3 d-flex align-items-start justify-content-between w-100">
              <div class="orders-status-main delivery-link past-orders">
                <h6 class="mb-1">{{past.restaurant_name}}</h6>
                <span v-html="$auth.setting.currency" class="currency"></span> 
                <!-- <span>{{ parseFloat(past.total_amount).toFixed(2)}}</span> -->
                <span>{{ past.total_amount }}</span>
                <p class="orderid">{{ $t('Order') }} #{{ past.id }}</p>                
                <span v-if="past.order_status == 'Delivered' && past.rating != '' " class="rate-box">{{past.rating}}<i class="fas active fa-star mr-2"></i></span>
                <p class="mt-2">{{moment(past.order_date).format("Do MMM YYYY hh:mm A")}}</p>
              </div>
            </div>
          </div>
        </router-link>
        <div class="new-btn-order">
          <div class="order-status" v-if="past.order_status == 'Delivered'">
            <p class="delivered order-status-btn">{{ $t('Delivered') }}</p>
          </div>
          <div class="order-status" v-else>
            <p class="canceled order-status-btn">{{ $t('Cancelled') }}</p>
          </div>
          <div class="reorder-div">
            <p class="order-status-btn reorder" @click="reorderClick(past)">{{ $t('Reorder') }}</p> 
            <div class="rating-div" v-if="past.order_status == 'Delivered' && past.rating == ''">
              <router-link class="ratelnk" :to="{name:'rating', params:{order_id: base64_encode(past.id)}}">{{$t('Rate')}}</router-link>
            </div>
          </div>          
        </div>
      </div>
    </div>
    <div v-else class="order-offers">
      <p class="text-center ml-1">{{ $t('No Past Order Found') }}</p>
    </div>
    </div>
    <!--Alert Modal start-->
    <AlertModal v-if="isAlert" :DisplayAlertData="AlertData" v-on:modalClose="onModalCloseFun"></AlertModal>
    <!--Alert Modal End-->
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import moment from "moment";
import VueSkeletonLoader from 'skeleton-loader-vue';
import AlertModal from '../../components/AlertModal.vue';
import noImge from "@/assets/images/place_holder.png";
import { CouponTypes } from "../../helper/helper.js";

export default {
  props:["selectTab"],
  components: { 'skeleton-loader-vue':VueSkeletonLoader,AlertModal },
  computed: {
    ...mapGetters("order",["pastOrder"]),
  },
  data() {
    return {
      rest_offer:[],
      couponTypes:CouponTypes,
      pastorders: [],
      perPage: 10,
      moment: moment,      
      isStopCallingApi:false,
      skip:0,
      is_skel_loader:true,
      isAlert: false,
      AlertData: {},
      tempOrder:{},
      firstApiCall:true,
      noImge,
      restaurant_id:''
    };
  },
  mounted() {
    if(this.selectTab == '1'){
      window.addEventListener("scroll", () => {
        if (window.innerHeight + window.scrollY >= document.body.offsetHeight) {
          if (!this.isStopCallingApi) {
            this.getPastOrders();
            this.is_skel_loader = false;
          }
        }
      });
      if(this.$route.name == 'orders' && this.firstApiCall){
        this.getPastOrders();
      }
    }
  },
  computed: {
      ...mapGetters("product", ["cart","offers"]),
      ...mapGetters("order",["isPickupDelivery"]),
    },
  methods: {
    ...mapActions("order",["newOrderListData","reorderDataDetails"]),
    ...mapMutations("product",["clearCartItems"]),
    ...mapActions("product", ["addOffers"]),
    ...mapActions("restaurant", ["getRestaurantOffers"]),

    allOffers(){
        this.getRestaurantOffers({
        restaurant_id: this.restaurant_id,
        vendor_id: this.$auth.getVendorId(),
        user_id: this.$auth?.user?.user_id ? this.$auth.user.user_id : '',
      }).then((data) => {
          if(data.code == 200){
            this.addOffers( data?.Result ?? []);
          }else{
            this.addOffers([]);
          }
      })
    },
    getPastOrders() {
      if(this.$route.name == 'orders' && this.selectTab == '1'){        
      this.is_skel_loader = true;
      this.newOrderListData({
        vendor_id: this.$auth.getVendorId(),
        is_langauge : this.$store.state.lang.locale,
        total_record: '100',
        skip:this.skip,
        user_id:this.$auth.user.user_id
        }).then((data) => {
        if (data.code == 200 && data.Result.length > 0) {
          this.firstApiCall = false;
          let allData = data.Result.reverse();
          //let allData = data.Result;
          this.is_skel_loader = false;
          this.skip = this.skip+100;
          if (!this.pastorders.length) {            
            allData.forEach((resOrder) => {              
              if(resOrder.order_status == 'Delivered' || resOrder.order_status =='Cancelled' || resOrder.order_status =='Refund'){                
                this.pastorders.push(resOrder);
              }
            });
          } else {
            allData.forEach((resOrder) => {              
              if(resOrder.order_status == 'Delivered' || resOrder.order_status =='Cancelled'){
                let checkRest = this.pastorders.find((elm) => elm.id == resOrder.id);
                if (!checkRest) {                  
                  this.pastorders.push(resOrder);
                }
              }
            });
          }
        } else if (data.Result.length == 0) {
          this.is_skel_loader = false;
          this.isStopCallingApi = true;
        }
        this.pastorders.sort((a, b) => b.id - a.id)
      });
      }
    },
  
    onModalCloseFun(value) {
      this.isAlert = false;
      if (value == 'yes') {
        this.$store.commit("product/clearCartItems");
        this.createCart(this.tempOrder);
      }
    },
    
    reorderClick(order){
      if(this.cart.length == 0){
        this.createCart(order);
      }else{
        var checkCartRestaurant= this.cart.find((ele) => (ele.restaurant_id == order.restaurant_id));
        if (checkCartRestaurant) {
          this.createCart(order);
        }else{
          this.AlertData = {
            displayMessage: this.$t('Your cart contain items from another store. Do you wish to clear cart and start a new order here?'),
            isSetClass: 'prdct-modal-cls'
            };
            this.isAlert = true;
            this.tempOrder = order;
            window.$("#item-popup").modal("hide");
            window.$(this.$refs.AlertModal).modal();
        }
      }
    },

    getOfferes(itemId) {
      let array = [];
      this.rest_offer.forEach((e) => {
        if (e.items.includes(Number(itemId)) && (this.couponTypes.BOGO == e.coupon_type || this.couponTypes.FREEBIE == e.coupon_type || this.couponTypes.FLATPRICE == e.coupon_type || this.couponTypes.FLATPERCENTAGE == e.coupon_type)) {
          array.push({ ...e, item_id: itemId });
        }
      });
      return array;
    },

    createCart(order){


      this.rest_offer = [...this.offers]
      this.reorderDataDetails({
        vendor_id: this.$auth.getVendorId(),
        is_langauge: this.$store.state.lang.locale,
        order_id : order.id,
      }).then((data) => {
        if (data.code == 200) {

          
          
          this.$store.commit("product/clearCartItems");
          let restaurant = data.restaurant_details ?? {};
          this.restaurant_id = restaurant.restaurant_id ?? 0;          
          if(!(this.offers && this.offers.length > 0)){
             this.allOffers();
          }
          if(data.Result.length > 0) {
            data.Result.forEach((res)=>{
              let roption = {};
              let selected_type = [];
              let customisation = [];
           
            let arraySelectCustoizeID = [];
            let arraySelectCustoizePrice = [];
            if(res.customize_type.length > 0){
              let option = [];
              customisation.length = 0;
              res.customize_type.forEach((elm) => {
                let arrangeItem = [];
                elm.option.forEach((elmoption) => {
                  arrangeItem.push({id:elmoption.selection_id});
                  selected_type.push(elmoption.selection_name);
                  arraySelectCustoizeID.push(elmoption.selection_id);
                  arraySelectCustoizePrice.push(elmoption.selection_price);
                  
                  if(elmoption.options.length > 0){
                    elmoption.options.forEach((elm)=>{
                      selected_type.push(elm.selection_name);
                      arraySelectCustoizeID.push(elm.selection_id);
                      arraySelectCustoizePrice.push(elm.selection_price);
                    });
                  }
                });
                if(arrangeItem && arrangeItem.length > 0){
                     customisation.push({ id:elm.customize_type_id,selected:arrangeItem});
                }
              });
             }
             var customizeTotal = arraySelectCustoizePrice.reduce((a, b) => a + b, 0);             
             var AddToCartItemArray = {
              restaurant_id: res.restaurant_id,
              item_id: res.item_id,
              item_name: res.item_name,
              price: customizeTotal+parseFloat(res.price),//res.amount/res.quantity,
              quantity: res.quantity,
              itemTotalQuantity: res.item_quantitys,
              selected_type: selected_type,
              selectCustoizeID: arraySelectCustoizeID,
              selectCustoizePrice: arraySelectCustoizePrice,
              item_type:res.item_type,
              item_price:res.price,
              image:res.image,            
              saveprice: res.saveprice,
              customisation:customisation,
              offer: this.getOfferes(parseInt(res.item_id)),
            };            
            this.$store.dispatch("product/addProductToCart", AddToCartItemArray);
            // this.$store.commit("product/creatReorderCart", AddToCartItemArray);
            if (this.$route.path != '/review-cart') {
              this.$router.push({ name: "review-cart"});
            }
            // this.$router.push({ name: "vendor", params: {delivery_type:(this.isPickupDelivery == '1'?'delivery':this.isPickupDelivery == '0'?'takeaway':this.isPickupDelivery == '2'?'reservation':''), restaurant_name: restaurant.slug} }).catch(()=>{});
            });

          }
        }
        if(data.inactive_item > 0){
          alert(this.$t("Few items are not available"));
        }
      });
    },   
  },
};
</script>
<style scoped>
.rate-box {
  padding: 0;
}

.rate-box .fas {
  padding-left: 3px;
}
</style>